import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'
import Home from '../views/home/Home.vue'

window.sessionStorage.setItem('loginType', 'business')

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/business-item',
    meta: { requiredLogin: true },
    component: Home,
    children: [
      {
        path: '/business-item',
        name: 'businessItem',
        meta: { requiredLogin: true },
        component: () => import('@/views/business-item/index.vue')
      },
      {
        path: '/manage-business-detail-log',
        name: 'manageBusinessUserDetailLog',
        meta: { requiredLogin: true },
        component: () => import('@/views/manage-business/log.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: { redirectAlreadyLogin: false },
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/404',
    name: 'NotFile',
    meta: { redirectAlreadyLogin: false },
    component: () => import('@/components/404.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from) => {
  const { commit, getters } = store
  const { requiredLogin } = to.meta
  commit('setIsRefresh', true)

  if (to.matched.length === 0) {
    return { name: 'NotFile', params: { path: from.path || '/' } }
  }
  if (!getters.getLogin && getters.getToken) {
    commit('setUser', { isLogin: true })
    return true
  }
  if (!getters.getLogin && requiredLogin) return { path: '/login' }
  return true
})

router.afterEach(to => {
  const { commit } = store
  commit('setIsRefresh', false)
  if (to.matched.length > 0) {
    if (to.meta.quick) {
      commit('setRouterList', { data: to })
    } else if (to.meta.path) {
      to.matched[0].children.forEach(item => {
        if (item.path === to.meta.path) {
          commit('setRouterList', { data: item })
        }
      })
    }
  }
})

export default router
